import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Loader } from '@lms/ui';
import { HubBackLink } from '@/components/hub/HubBackLink';
import { H5pPlayer } from '@/components/h5p/H5pPlayer';
import type { H5pPlayerPayload } from '@/components/h5p/types';
import { api } from '@/lib/api';
import { withLibraryContext } from '@/lib/library-navigation';

export function H5pPreviewPage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const { data, isLoading, error } = useQuery({
    queryKey: ['h5p', id, 'player'],
    queryFn: () => api<H5pPlayerPayload>(`/h5p/player/${id}`),
    enabled: Boolean(id),
  });
  const detailUrl = id ? withLibraryContext(`/h5p/${id}`, searchParams) : '/h5p';

  return (
    <div className="lms-site-admin-hub-page font-sans">
      <header className="mb-8 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-start gap-4">
          <HubBackLink to={detailUrl} />
          <div className="min-w-0">
            <h1 className="text-3xl font-semibold text-dash-primary md:text-4xl">Vista previa H5P</h1>
            {data?.title && (
              <p className="mt-1 text-sm text-dash-on-surface-variant">{data.title}</p>
            )}
          </div>
        </div>
        {id && (
          <Link to={detailUrl} className="lms-h5p-library__btn lms-h5p-library__btn--outline">
            Ver detalle
          </Link>
        )}
      </header>

      {error && (
        <p className="mb-4 text-sm text-red-600" role="alert">
          {(error as Error).message}
        </p>
      )}

      {isLoading ? (
        <div className="flex justify-center py-12">
          <Loader />
        </div>
      ) : data ? (
        <div className="lms-h5p-preview">
          <H5pPlayer key={data.contentId ?? id} player={data} />
        </div>
      ) : null}
    </div>
  );
}
